document.addEventListener('DOMContentLoaded', function () {
  // Function that applies rental text to a single product card
  function processCard(card) {
    if (!card) return;

    // Only apply to products that use your rental template
    var suffix = card.getAttribute('data-template-suffix') || '';

    if (suffix !== 'basic-local-with-rental') {
      return; // skip non-rental products
    }

    // Avoid duplicates if something re-renders
    if (card.querySelector('.product-card__rental')) return;

    // There can be multiple .price elements (hover/zoom variants).
    // We want the *visible* one in the main card content, which is
    // the LAST .price inside the card.
    var priceEls = card.querySelectorAll('.price');
    if (!priceEls.length) return;

    var priceEl = priceEls[priceEls.length - 1];
    if (!priceEl) return;

    // Get numeric price in pounds from text like "£1,499.00"
    var text = priceEl.textContent || '';
    var numeric = parseFloat(text.replace(/[^0-9.]/g, ''));

    if (!numeric || isNaN(numeric)) return;

    // --- RENTAL CALCULATION ---
    // 5% of product price
    var monthlyBase = numeric * 0.0333;

    // Round UP to the nearest whole pound
    var monthlyRounded = Math.ceil(monthlyBase);

    // Deduct 5p
    var monthlyFinal = monthlyRounded - 0.05;

    // Format to 2 decimal places (string)
    var rentalFormatted = monthlyFinal.toFixed(2);

    // Build the rental HTML.
    // Inline styles so it's always visible regardless of theme CSS.
    var html =
      '<p class="product-card__rental">' +
      'Rent £' + rentalFormatted + ' per month' +
      '</p>';

    // -------------------------------
    // Decide WHERE to insert the line
    // -------------------------------
    var targetEl = null;

    // 1) If there are promo straplines, put rental AFTER the last one
    var promoEls = card.querySelectorAll('.promo-strapline');
    if (promoEls.length) {
      targetEl = promoEls[promoEls.length - 1];
    } else {
      // 2) Otherwise try stock message (In Stock / Available to Order etc.)
      var stockEl = card.querySelector('[data-stock-msg]');
      if (stockEl) {
        targetEl = stockEl;
      } else {
        // 3) Fallback: just put it under the price
        targetEl = priceEl;
      }
    }

    if (targetEl) {
      targetEl.insertAdjacentHTML('afterend', html);
    }
  }

  // Run on all existing cards at initial page load
  var initialCards = document.querySelectorAll('.product-card');
  initialCards.forEach(processCard);

  // Watch for any new product cards added later (pagination, "Load more", filters, etc.)
  var observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        // Only care about HTMLElements
        if (!(node instanceof HTMLElement)) return;

        // If the added node itself is a product card
        if (node.classList && node.classList.contains('product-card')) {
          processCard(node);
        }

        // Or if it contains product cards inside it
        var nestedCards = node.querySelectorAll && node.querySelectorAll('.product-card');
        if (nestedCards && nestedCards.length) {
          nestedCards.forEach(processCard);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
